import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Helmet } from "react-helmet";
import { Grid, PageWrapper } from "components/Containers";
import { SearchInput } from "components/Search";
import { NETWORK_LIST_BADGES_OPTIONS } from "constants/index";
import { Banner, BannerShowcaseSignup, BookMeetingMemberBanner } from "components/Banner";
import { useNetworkControls, useQueryData } from "hooks";
import { HireButton } from "components/Profile";
import { NetworkList, NetworkListControls } from "components/Network";
import { ListFavoriteButton } from "components/Lists";
import Disclaimer from "components/Disclaimer";
import { GET_MEMBERS_COUNT } from "graphql/queries";

/**
 * ClientSearch
 */
const ClientSearch = () => {
  const intl = useIntl();
  const resultsPerPage = 18;
  const { data: { membersCount } = {} } = useQueryData({ queryName: GET_MEMBERS_COUNT });
  const { filterMetadata, data, ...rest } = useNetworkControls({
    resultsPerPage,
    initialValues: {
      filters: {
        badges: [NETWORK_LIST_BADGES_OPTIONS.featured],
      },
    },
  });

  return (
    <>
      <SearchInput onChange={rest?.handleSearchInputChange} initialValue={rest?.keyword}>
        <BannerShowcaseSignup />
      </SearchInput>
      <PageWrapper>
        <Helmet>
          <title>{intl.formatMessage({ id: "Meta.ClientSearch.Title" })}</title>
        </Helmet>
        <Banner keyName="showClientSearchBanner">
          <FormattedMessage
            id="Client.Search.Banner.Title1"
            values={{
              intro: (
                <b>
                  <FormattedMessage id="Client.Search.Banner.Title2" />
                </b>
              ),
            }}
          />
        </Banner>
        <Grid topMargin>
          <Grid.col start={1} end={13}>
            <NetworkListControls formValues={filterMetadata} hideKeywordSearch hideSorts {...rest} />
          </Grid.col>
          <Grid.col start={1} end={13}>
            <NetworkList
              actions={[HireButton, ListFavoriteButton]}
              resultsPerPage={resultsPerPage}
              data={data}
              membersCount={membersCount}
              isCardView
              {...rest}
            />
          </Grid.col>
          <Grid.col start={1} end={13}>
            <BookMeetingMemberBanner />
          </Grid.col>
          <Grid.col start={1} end={13}>
            <Disclaimer />
          </Grid.col>
        </Grid>
      </PageWrapper>
    </>
  );
};

export default ClientSearch;
